import React, { createContext, useState, useEffect, useContext } from 'react';
import { AppStateService } from './AppState';

export const AppContext = createContext();
export const LMDrawingContext = createContext();
export const LMShowEllipseContext = createContext();
export const ViewOnlyContext = createContext();
export const ThemeContext = createContext();
export const TaskIdDataContext = createContext();

let externalSetViewOnly;
let externalGetViewOnly;

export const AppProvider = ({ children }) => {
    const [isInApp, setIsInApp] = useState(false);
    const [lmDrawing, setLMDrawing] = useState('');
    const [LMShowEllipse, setLMShowEllipse] = useState(false);
    const [viewOnly, setViewOnly] = useState(false);
    const [taskIdData, setTaskIdData] = useState(null);
    const [theme, setTheme] = useState(
        () => localStorage.getItem('theme') || 'dark');

    const usesApp = (data) => {
        
        setIsInApp(true);
    };

    useEffect(() => {
        window.addEventListener('usesApp', usesApp);

        return () => {
            window.removeEventListener('usesApp', usesApp);
        }
    }, []);

    const localSetViewOnly = (value) => {
        setViewOnly(value);
    }

    externalSetViewOnly = localSetViewOnly;

    externalGetViewOnly = () => {
        return viewOnly;
    }

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    const setAppTheme = newTheme => {
        if (newTheme === 'light' || newTheme === 'dark') {
            setTheme(newTheme);
        } else {
            console.warn('Invalid theme:', newTheme);
        }
    };

    return (
        <AppContext.Provider value={{ isInApp, setIsInApp }}>
            <LMDrawingContext.Provider value={{ lmDrawing, setLMDrawing }}>
                <LMShowEllipseContext.Provider value={{ LMShowEllipse, setLMShowEllipse }}>
                    <ViewOnlyContext.Provider value={{ viewOnly, setViewOnly }}>
                        <TaskIdDataContext.Provider value={{ taskIdData, setTaskIdData }}>
                            <ThemeContext.Provider value={{ theme, setAppTheme }}>
                                {children}
                            </ThemeContext.Provider>
                        </TaskIdDataContext.Provider>
                    </ViewOnlyContext.Provider>
                </LMShowEllipseContext.Provider>
            </LMDrawingContext.Provider>
        </AppContext.Provider>
    );
};

export const updateViewOnly = (value) => {
    if (externalSetViewOnly) {
        externalSetViewOnly(value);
    } else {
        console.log("not init yet");
    }
}

export const getViewOnly = () => {
    return externalGetViewOnly();
}
